export default "__VITE_ASSET__Dg$eFb3P__"